import { Component, OnInit, Inject, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl} from '@angular/forms';
import { UsersService } from '../../../pages/users/users.service';
import { GeneralService } from '../../services/general.service';
import { Business } from './business.model';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-select-business',
  templateUrl: './select-business.component.html',
  styleUrls: ['./select-business.component.scss'],
  providers: [ UsersService, GeneralService ]
})
export class SelectBusinessComponent implements OnInit {
  public businesses: Business[];
  // public businessCtrl = new FormControl([null, Validators.compose([Validators.required])]);
  public businessCtrl = new FormControl();
  @Output() public onChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() public businessId: number;

  constructor(private usersService: UsersService, private generalService: GeneralService) {

  }

  ngOnInit() {
    this.generalService.getBusiness().subscribe(businesses => {
      this.businesses = businesses;
      this.businessCtrl.setValue(this.businessId);
    });
  }

  change(e) {
    console.log(e);
    this.onChange.emit(e);
  }

}
